import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';
import { TypedFormGroup, TypedFormControl } from '@principle-theorem/ng-shared';
import {
  IAccProsthesis,
  AccBooleanValue,
  AccProsthesisType,
  AccToothNumber,
} from '@principle-theorem/principle-core/interfaces';
import { filterUndefined } from '@principle-theorem/shared';
import { setRequiredValidation, hasRequiredError } from './form-group-helpers';

export class AccProsthesisFormGroup extends TypedFormGroup<IAccProsthesis> {
  constructor() {
    super({
      wornAtTimeOfInjury: new TypedFormControl<AccBooleanValue>(
        undefined,
        Validators.required
      ),
      prosthesisType: new TypedFormControl<AccProsthesisType[]>(undefined),
      teethOnPartialDenture: new TypedFormControl<AccToothNumber[]>(undefined),
    });

    // prosthesisType is required when wornAtTimeOfInjury is true
    this.controls.wornAtTimeOfInjury.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) =>
        setRequiredValidation(value, this.controls.prosthesisType)
      );
  }

  get wornAtTimeOfInjuryRequiredError(): boolean {
    return hasRequiredError(this.controls.wornAtTimeOfInjury);
  }

  get prosthesisTypeRequiredError(): boolean {
    return hasRequiredError(this.controls.prosthesisType);
  }

  get displayProsthesisType(): boolean {
    return this.controls.wornAtTimeOfInjury.value === AccBooleanValue.True;
  }
}
